import { Form, Tabs } from 'antd';
import { memo } from 'react';

import { CurrencyWrapper } from 'app/components/commons/Currency/CurrencyWrapper/CurrencyWrapper';
import { useGetHotel } from 'app/hooks/data/hotels/useHotel';

import { MenuItemName } from '../menuItem';

import { Copywriting } from './Copywriting/Copywriting';
import { Disclaimer } from './Disclaimer/Disclaimer';
import { ExperiencesAndRooms } from './ExperiencesAndRooms/ExperiencesAndRooms';
import { General } from './General/General';
import { Limitations } from './Limitations/Limitations';
import { Medias } from './Medias/Medias';

export const PackForm = memo(({ itemName }: { itemName: MenuItemName }) => {
  const form = Form.useFormInstance();
  const hotelId = Form.useWatch(['hotelId'], form);
  const isDaytime = Form.useWatch('isDaytime', form);

  const { data: hotel } = useGetHotel(hotelId);

  const tabs = [
    {
      key: MenuItemName.General,
      label: 'General',
      children: <General />,
    },
    {
      key: MenuItemName.ExperiencesAndRooms,
      label: 'Activities & Rooms',
      children: <ExperiencesAndRooms />,
    },
    {
      key: MenuItemName.Limitations,
      label: 'Limitations',
      children: <Limitations />,
    },
    {
      key: MenuItemName.Copywriting,
      label: 'Copywriting',
      children: <Copywriting />,
    },
    ...(isDaytime
      ? [
          {
            key: MenuItemName.Disclaimer,
            label: 'Disclaimer',
            children: <Disclaimer />,
          },
          {
            key: MenuItemName.Medias,
            label: 'Medias',
            children: <Medias />,
          },
        ]
      : []),
  ];

  return (
    <CurrencyWrapper hotel={hotel}>
      <Tabs
        activeKey={itemName}
        onChange={() => null}
        renderTabBar={() => <></>}
        items={tabs}
      />
    </CurrencyWrapper>
  );
});

PackForm.displayName = 'PackForm';
